import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Sound } from "@pixi/sound";
export class SoundsResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("SoundsResourcePackage");
    }
    public get assets_sounds_Card_Flip_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Card_Flip.mp3");
    }
    public get assets_sounds_Card_Zoom_In_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Card_Zoom_In.mp3");
    }
    public get assets_sounds_Choose_Card_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Choose_Card.mp3");
    }
    public get assets_sounds_Coins_Top_Bar_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Coins_Top_Bar.mp3");
    }
    public get assets_sounds_Collect_Screen_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Collect_Screen.mp3");
    }
    public get assets_sounds_Dice_Button_Click_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Dice_Button_Click.mp3");
    }
    public get assets_sounds_Popups_Entering_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Popups_Entering.mp3");
    }
    public get assets_sounds_Raid_Correct_Target_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Raid_Correct_Target.mp3");
    }
    public get assets_sounds_Roll_09_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/Roll_09.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_4x_more_appear_v2_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_4x_more_appear_v2.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_X_click_on_purchase_fail_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_X_click_on_purchase_fail.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_collect_button_click_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_collect_button_click.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_daily_wheel_spin_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_daily_wheel_spin.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_free_spin_click_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_free_spin_click.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_golden_wheel_spin_button_v2_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_golden_wheel_spin_button_v2.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_golden_wheel_spin_v2_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_golden_wheel_spin_v2.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_purchase_button_click_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_purchase_button_click.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_purchase_fail_screen_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_purchase_fail_screen.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_wheel_and_text_appear_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_wheel_and_text_appear.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_win_screen_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_win_screen.mp3");
    }
    public get assets_sounds_goldenwheel_new_wheel_win_screen_disappear_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/goldenwheel/new_wheel_win_screen_disappear.mp3");
    }
    public get assets_sounds_hand_movemet_general_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/hand_movemet_general.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_X_button_click_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_X_button_click.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_click_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_click.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_click_of_coins_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_click_of_coins.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_home_button_click_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_home_button_click.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_info_double_general_in_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_info_double_general_in.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_info_single_general_in_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_info_single_general_in.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_info_single_general_out_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_info_single_general_out.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_player_card_comes_in_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_player_card_comes_in.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_scrolling_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_scrolling.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_xp_amount_appear_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_xp_amount_appear.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_xp_amount_gain_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_xp_amount_gain.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_zoom_in_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_zoom_in.mp3");
    }
    public get assets_sounds_myBuildings_upgrade_zoom_out_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/myBuildings/upgrade_zoom_out.mp3");
    }
    public get assets_sounds_targets_Appear_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/targets_Appear.mp3");
    }
    public get assets_sounds_upgrade_card_select_upgrade_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/upgrade_card_select_upgrade.mp3");
    }
    public get assets_sounds_upgrade_click_back_arrow_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/upgrade_click_back_arrow.mp3");
    }
    public get assets_sounds_upgrade_coin_win_card_highlight_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/upgrade_coin_win_card_highlight.mp3");
    }
}

